import React from 'react';
import * as PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import AddPhotoSummary from './AddPhotoSummary';
import AddVehicleHeader from '../AddVehicleHeader';
import AddVehicleContentWrapper from '../AddVehicleContentWrapper';
import { getDraft, saveAddPhotoDraft } from '../AddVehicleActions';
import AddVehicleFooter from '../AddVehicleFooter';

const AddPhotoSummaryPage = ({ prevForm, nextForm, values, form }) => {
  const dispatch = useDispatch();
  const id = useSelector(state => state.addVehicle.get('id'));
  const isLoading = useSelector(state => state.navbarLoader.get('isLoading'));

  function handleSaveDraftButton() {
    dispatch(saveAddPhotoDraft()).then(() => dispatch(getDraft(id)));
  }

  return (
    <>
      <AddVehicleHeader saveDraftButtonHandler={handleSaveDraftButton} />
      <AddVehicleContentWrapper>
        <AddPhotoSummary prevForm={prevForm} nextForm={nextForm} values={values} form={form} />
      </AddVehicleContentWrapper>
      <AddVehicleFooter
        nextButtonHandler={() => {
          handleSaveDraftButton();
          nextForm();
        }}
        backButtonHandler={prevForm}
        nextButtonDisabled={isLoading}
      />
    </>
  );
};

AddPhotoSummaryPage.propTypes = {
  prevForm: PropTypes.func.isRequired,
  nextForm: PropTypes.func.isRequired,
};

export default AddPhotoSummaryPage;
